import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const TicketComment = ({ comment }) => {
	return (
		<div className="ticketComment">
			<div className="comment-header">
				<span>Comment:</span>
			</div>
			<div className="comment-content">
				<span>{comment}</span>
			</div>
		</div>
	)
}

TicketComment.propTypes = {
	comment: PropTypes.string,
}

export default TicketComment
